// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__N68un","selects":"Documents_selects__3k05a"};